import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataResposta = (): TabelaColuna => ({
  Chave: 'dataResposta',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataResposta)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Data Resposta</div>
})
